import { Link, useLocation } from 'react-router-dom';
import "./Mobile_prepaid_plan_card.css";

function Mobile_prepaid_plan_card() {
    const location = useLocation();

    // Check if current path is "/mobile-prepaid-recharge"
    const isPrepaidRechargePage = location.pathname === "/mobile-prepaid-recharge";

    return (
        <section className='Mobile_prepaid_plan_card_holder'>
            <div className="prepaid_plan_card_holder">
                <div className="row align-items-center">
                    <div className="col-md-2 col-sm-2  col-3">
                        <div className="img_holder">
                            <img
                                src="/assets/images/services/recharge_logo/tata_sky.png"
                                alt="Airtel"
                                className='recharge_sim_img'
                            />
                        </div>
                    </div>

                    <div className="col-md-10 col-sm-10  col-9">
                        <div className="text_holder">
                            <div className='card_name_holder'>
                                <h5>Airtel Prepaid</h5>
                                <div className="number_text_holder">
                                    <p>8864732301</p>

                                    {!isPrepaidRechargePage && (
                                        <h6>
                                            Jio | Mumbai <Link to="/mobile-recharge"><span>Change</span></Link>
                                        </h6>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mobile_prepaid_plan_card;
